import { render, staticRenderFns } from "./CbsTableRecordStatus.vue?vue&type=template&id=1dae1f5e&scoped=true"
import script from "./CbsTableRecordStatus.vue?vue&type=script&lang=js"
export * from "./CbsTableRecordStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dae1f5e",
  null
  
)

export default component.exports